import type { ProfileResponse } from "~/api/auth"

const API_BASE = "/api/v1"

const jsonHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
}

export type PlusBillingInterval = "monthly" | "annual"

export interface PlusPricing {
  annual: {
    amount_display: string
    interval: "annual"
    per_month_display: string
    savings_display: string
    recommended: boolean
  }
  monthly: {
    amount_display: string
    interval: "monthly"
    recommended: boolean
  }
  billing_mode: "stripe" | "grant"
}

export type StartPlusResponse =
  | (ProfileResponse & { mode: "grant" | "already_member" })
  | { mode: "stripe"; checkout_url: string }

async function apiErrorMessage(res: Response): Promise<string> {
  const err = (await res.json().catch(() => null)) as { errors?: string[] } | null
  if (err?.errors?.length) return err.errors.join(", ")
  return res.statusText || "Request failed"
}

export async function getPlusPricing(): Promise<PlusPricing> {
  const res = await fetch(`${API_BASE}/plus/pricing`, { credentials: "include" })
  if (!res.ok) throw new Error(await apiErrorMessage(res))
  return res.json()
}

export async function startPlus(billingInterval: PlusBillingInterval): Promise<StartPlusResponse> {
  const res = await fetch(`${API_BASE}/plus/start`, {
    method: "POST",
    headers: jsonHeaders,
    credentials: "include",
    body: JSON.stringify({ billing_interval: billingInterval }),
  })
  if (!res.ok) throw new Error(await apiErrorMessage(res))
  return res.json()
}

export async function openPlusPortal(): Promise<{
  mode: string
  url?: string | null
  message?: string | null
}> {
  const res = await fetch(`${API_BASE}/plus/portal`, {
    method: "POST",
    headers: jsonHeaders,
    credentials: "include",
    body: "{}",
  })
  if (!res.ok) throw new Error(await apiErrorMessage(res))
  return res.json()
}

export async function markPlusWelcomeSeen(): Promise<{ plus_welcome_seen_at: string | null }> {
  const res = await fetch(`${API_BASE}/plus/welcome_seen`, {
    method: "POST",
    headers: jsonHeaders,
    credentials: "include",
    body: "{}",
  })
  if (!res.ok) throw new Error(await apiErrorMessage(res))
  return res.json()
}
